import { AddEditClient, ClientMgmt } from "@/pages";
import { routes } from "../utils";

export const ClientMgmtRoutes = () => {
  return {
    path: routes.clientMgmt,
    children: [
      {
        path: "",
        element: <ClientMgmt />,
      },
      {
        path: routes.add,
        element: <AddEditClient />,
      },
      {
        path: routes.id + "/" + routes.action,
        element: <AddEditClient />,
      },
    ],
  };
};
